import Controller from '../abstracts/Controller';
import 'scss-templates/t-editorial-listing.scss';

export default class EditorialListingController extends Controller {
  static get COMPONENTS() {
    return [
      'FiltersComponent',
      'GeneralComponentsComponent',
      'NewsletterComponent',
      'ShowPasswordComponent',
      'SimpleBarComponent',
      'TripleImageTextComponent',
      'EditorialButterflyComponent',
      'AddToWishlistComponent',
      'WishlistComponent',
      'CountdownComponent',
      'SeoTextComponent'
    ];
  }
}
